export const payment = {
  setup_payment_head: "Setup Payment Methods",
  setup_payment:
    "Please complete your setup by confirming account plan and selecting payment period",

  payment_period_head: "Payment Period",
  payment_period: "Please select whether you want to pay monthly or yearly",

  no_payment_required: "No payment required",
  no_change: "No change in plan or period",
  payment_proration:
    "If you switch payment plan now, approximately $AMOUNT$ (excl. VAT) from current payment period will be held in credit and be deducted from future payments.",

  button_setup_payment: "Setup payment",

  head_setup_payment_success: "Thank you!",
  setup_payment_success:
    "Your subscription has been created. Click close to access your account.",

  head_setup_payment_failed: "Unable to setup subscription",
  setup_payment_failed:
    "We were unable to finish the setup of your subscription. Please try again.",

  errorbar_payment_overdue_title: "Payment overdue!",
  errorbar_payment_overdue_text:
    "Please update your payment method in the Payment Portal.",
  errorbar_payment_overdue_extra_info:
    "All your onelinks are still working as before, but you will not be able to make changes or see statistics until your subscription invoices are settled.",
  errorbar_payment_overdue_action: "Open Payment Portal",
  errorbar_payment_overdue_action_short: "Open",

  errorbar_cancelled_over_free_limit_title: "To many onelinks in account!",
  errorbar_cancelled_over_free_limit_text:
    "After your subscription ended, your account converted to the Free plan. Please take action.",
  errorbar_cancelled_over_free_limit_info:
    "All your onelinks are still working as before, but you will not be able to make changes or see statistics until you have deleted links or started a new subscription.",
};
